var css = {"linkBase":"LinkBase-module_linkBase__6HZT3"};

export { css as default };
